export default {
  row: {
    display: 'flex',
    gap: '20px',
    '& .MuiAutocomplete-root': {
      padding: 0,
    },
    '& .MuiPaper-root': {
      background: '#fff !important',
    },
    '& .MuiAutocomplete-listbox': {
      padding: '0 !important',
    },
    '& .MuiPopper-root': {
      padding: '0 !important',
      background: '#fff !important',
    },
  },
  checkBoxWrapper: {
    display: 'flex',
    flexDirection: 'row',
    borderRadius: '4px',
    border: (theme) => `1px solid ${theme.palette.grays.gray200}`,
    padding: '12px',
    margin: 0,
    'div:last-of-type': {
      width: 'auto',
    },
  },
};
